import { ComponentUtils } from '@/mixins';
import ShCard from '@/components/Helpers/ShCard';

// @vue/component
export default {
  name: 'WidgetScreensPreview',

  components: {
    ShCard,
  },

  mixins: [ComponentUtils],

  props: {
    widget: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      selectedScreen: 'welcome',
      focusedElement: null,
    };
  },

  computed: {
    mockedHotlineDetails() {
      const { selectedScreen } = this;
      return {
        menu: 'Powitanie',
        agent: selectedScreen === 'talking' ? 'Jan Kowalski' : null,
        hotlineNumber: '123 456 123',
      };
    },
    shouldShowFeedbackElement() {
      return this.widget.config.feedback_after_conection_is_enabled;
    },
  },

  created() {
    this.mMakeCopyFromProps('widget');
    this.$EventBus.$on('WidgetScreensConfiguration/SET_SELECTED_SCREEN', (selectedScreen) => {
      const mapForSpecificScreenAccordingToWidge = {
        modal_welcome: 'welcome',
        modal_welcome_after_hours: 'welcome_afterhours',
      };
      this.selectedScreen = mapForSpecificScreenAccordingToWidge[selectedScreen] || selectedScreen;
    });
    this.$EventBus.$on('WidgetScreensConfiguration/SET_FOCUS_TO_EDITED_ELEMENT', (element) => {
      this.focusedElement = element;
    });
  },

  beforeDestroy() {
    this.$EventBus.$off('WidgetScreensConfiguration/SET_SELECTED_SCREEN');
    this.$EventBus.$off('WidgetScreensConfiguration/SET_FOCUS_TO_EDITED_ELEMENT');
  },
};
